import { render, staticRenderFns } from "./CreateRegister.vue?vue&type=template&id=33663df1&scoped=true&"
import script from "./CreateRegister.vue?vue&type=script&lang=js&"
export * from "./CreateRegister.vue?vue&type=script&lang=js&"
import style0 from "./CreateRegister.vue?vue&type=style&index=0&id=33663df1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33663df1",
  null
  
)

export default component.exports